module.exports = __webpack_public_path__ + "img/s.0812810a.webp";